export default __webpack_public_path__ + "static/media/home_metting_empty_img@2x.f23df5fb.png";